module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/solid/island-tropical.svg?e9f9151ef3e7678d374962f8311e1bd3";